import IdeyaModal from '../../../../../common/antd/ideya-modal.tsx'
import IdeyaTypography from '../../../../../common/antd/ideya-typography.tsx'
import { useTranslation } from 'react-i18next'

interface ActionUserStatusModalProps {
  activeInactiveModal: boolean
  onSubmit: () => void
  onClose: () => void
}

export const ActionUserStatusModal: React.FC<ActionUserStatusModalProps> = ({
  activeInactiveModal,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation()
  return (
    <IdeyaModal
      open={activeInactiveModal}
      title={t('user_management.user_modal.action_user_status.confirmation')}
      destroyOnHidden
      onOk={onSubmit}
      onCancel={onClose}
    >
      <IdeyaTypography.Text>
        {t('user_management.user_modal.action_user_status.are_you_sure_status')}
      </IdeyaTypography.Text>
    </IdeyaModal>
  )
}
